const holders = ref(0)

const notify = (name: 'dialog-open' | 'dialog-close') =>
  bridge.sendMessage({ name, payload: {} })

export function useHostDialog(onHostClose?: () => void) {
  let isHolding = false

  const handleMessage = (event: MessageEvent) => {
    if (event.data?.name === 'dialog-close') onHostClose?.()
  }

  const open = () => {
    if (isHolding) return

    isHolding = true
    holders.value += 1

    if (holders.value === 1) notify('dialog-open')
    if (onHostClose) window.addEventListener('message', handleMessage)
  }

  const close = () => {
    if (!isHolding) return

    isHolding = false
    holders.value = Math.max(0, holders.value - 1)

    if (holders.value === 0) notify('dialog-close')
    if (onHostClose) window.removeEventListener('message', handleMessage)
  }

  onUnmounted(close)

  return { open, close }
}
